import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { unsuspendCards } from '../api/simActionsApi';

export const useUnsuspendMutation = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return unsuspendCards(props);
    },
  });
};
